import axios from "axios";

export const getServices = async () => {
  try {
    const response = await axios.post(
      "http://localhost/idealtechnoride/api/service"
    );

    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};